import Urls from '../Urls'
import { axiosInstance } from "./AxiosInstance"
class TeachersListReq {
    FindTeacher = (params) => {
        return axiosInstance({
            url : Urls.teacherList(),
            method : 'get' ,
            params
        })
    }
}
export default new TeachersListReq